<template>
  <div>
    <b-row>
      <b-col>
        <b-card class="header-marcar_consulta bg-gradient-primary">
          <b-row align-v="center">
            <b-col lg="6">
              <h1>
                <feather-icon icon="UsersIcon" size="30" class="mr-50" />
                Turmas do Professor: {{ professor?.fullName }}
              </h1>
            </b-col>
            <b-col lg="3">
              <b-button variant="secondary" @click="$router.go(-1)">
                <feather-icon icon="ArrowLeftIcon" size="16" class="mr-50" />
                Voltar
              </b-button>
            </b-col>
            <b-col lg="3">
              <b-button variant="primary button-right" @click="vincularTurma">
                <feather-icon icon="PlusIcon" size="16" class="mr-50" />
                Vincular Turma
              </b-button>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>

    <!-- Informações do Professor -->
    <b-card class="mb-2">
      <b-row>
        <b-col md="6">
          <h6>Informações do Professor</h6>
          <p><strong>Nome:</strong> {{ professor?.fullName }}</p>
          <p><strong>Email:</strong> {{ professor?.email }}</p>
          <p><strong>Disciplina:</strong> {{ professor?.discipline }}</p>
        </b-col>
                 <b-col md="6">
           <h6>Escolas</h6>
           <div v-if="escolasDistinct && escolasDistinct.length > 0">
             <b-badge 
               v-for="escola in escolasDistinct" 
               :key="escola"
               variant="info" 
               class="mr-1 mb-1"
             >
               {{ escola }}
             </b-badge>
           </div>
           <p v-else class="text-muted">Nenhuma escola vinculada</p>
         </b-col>
      </b-row>
    </b-card>

    <!-- Lista de Turmas -->
    <b-card no-body class="mb-0">
      <b-card-header>
        <h5>Turmas Vinculadas</h5>
      </b-card-header>
      
      <b-table
        ref="refTurmasTable"
        style="min-height: 50vw"
        class="position-relative"
        :items="professor?.turmas || []"
        responsive
        :fields="tableColumns"
        primary-key="id"
        show-empty
        empty-text="Nenhuma turma vinculada a este professor"
      >
        <template #cell(index)="data">
          {{ data.index + 1 }}
        </template>
        <template #cell(actions)="data">
          <b-button
            variant="outline-danger"
            size="sm"
            @click="desvincularTurma(data.item)"
          >
            <feather-icon icon="XIcon" size="14" />
            Desvincular
          </b-button>
        </template>
      </b-table>
    </b-card>

    <!-- Modal para Vincular Turma -->
    <b-modal
      id="modal-vincular-turma"
      title="Vincular Nova Turma"
      size="lg"
      scrollable
      @ok="confirmarVinculacao"
      @hidden="resetVinculacaoForm"
      ok-title="Vincular"
      cancel-title="Cancelar"
      style="height: 400px;"
    >
      <b-form @submit.prevent="confirmarVinculacao">
        <b-row>
          <b-col md="6">
            <b-form-group label="Escola" label-for="v-school">
              <v-select
                id="school"
                v-model="vinculacaoForm.schoolId"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="schoolOptions"
                value="id"
                label="name"
                placeholder="Selecione uma escola"
                @input="onSchoolChange"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Turma" label-for="v-classroom">
              <v-select
                id="classroom"
                v-model="vinculacaoForm.classroomId"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="classroomOptions"
                value="id"
                label="name"
                placeholder="Selecione uma turma"
                :disabled="!vinculacaoForm.schoolId"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardHeader,
  BButton,
  BTable,
  BBadge,
  BModal,
  BForm,
  BFormGroup,
} from 'bootstrap-vue'
import { hideSpinner, showSpinner } from '@/services/spinService'
import usersService from '@/services/usersService'
import schoolService from '@/services/schoolService'
import classroomService from '@/services/classroomService'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'

export default {
  components: {
    BCard,
    BCardHeader,
    BTable,
    BBadge,
    BModal,
    BForm,
    BFormGroup,
    BRow,
    BCol,
    BButton,
    vSelect,
    ToastificationContent,
  },
  data: () => ({
    professor: null,
    schoolOptions: [],
    classroomOptions: [],
    vinculacaoForm: {
      schoolId: null,
      classroomId: null,
    },
    tableColumns: [
      { key: 'index', label: '#', sortable: false },
      { key: 'turma', label: 'Nome da Turma', sortable: false },
      { key: 'turno', label: 'Turno', sortable: false },
      { key: 'ano', label: 'Ano', sortable: false },
      { key: 'escola', label: 'Escola', sortable: false },
      { key: 'actions', label: 'Ações', sortable: false },
    ],
  }),
     async mounted() {
     await this.loadProfessor()
     await this.loadSchools()
   },
   computed: {
     escolasDistinct() {
       if (!this.professor?.turmas) return []
       
       // Extrai nomes únicos das escolas das turmas
       const escolas = this.professor.turmas.map(turma => turma.escola)
       return [...new Set(escolas)]
     },
   },
  methods: {
    async loadProfessor() {
      try {
        showSpinner()
        const professorId = this.$route.params.id
        this.professor = await usersService.getProfessorTurmas(professorId)
        hideSpinner()
      } catch (error) {
        hideSpinner()
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Erro ao carregar dados do professor',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      }
    },

    async loadSchools() {
      try {
        const filtro = {
          name: '',
          page: 1,
          itemsPerPage: 99,
        }
        const response = await schoolService.getAll(filtro)

        this.schoolOptions = response.content || []
      } catch (error) {
        console.error('Erro ao carregar escolas:', error)
      }
    },

         async onSchoolChange(school) {
       this.vinculacaoForm.classroomId = null
       this.classroomOptions = []
       const schoolName = school.name;
       if (!schoolName) return

             try {
         const filtro = {
           name: '',
           page: 1,
           itemsPerPage: 99,
         }
         const response = await classroomService.getAll(filtro)

                 // Filtra turmas da escola selecionada
         this.classroomOptions = (response.content || [])
           .filter(classroom => classroom.escola === schoolName)
           .map(classroom => ({
             ...classroom, 
             name: classroom.ano + ' - ' + classroom.turma + ' ' + classroom.turno
           }))
      } catch (error) {
        console.error('Erro ao carregar turmas:', error)
      }
    },

    vincularTurma() {
      this.$bvModal.show('modal-vincular-turma')
    },

    async confirmarVinculacao() {
      if (!this.vinculacaoForm.schoolId || !this.vinculacaoForm.classroomId) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Selecione uma escola e uma turma',
            icon: 'AlertTriangleIcon',
            variant: 'warning',
          },
        })
        return
      }

      try {
        showSpinner()
        
                 await usersService.vincularTurma({
           professorId: this.professor.id,
           turmaId: this.vinculacaoForm.classroomId.id,
           escola: this.vinculacaoForm.schoolId.name,
         })

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Turma vinculada com sucesso!',
            icon: 'CheckIcon',
            variant: 'success',
          },
        })

        this.$bvModal.hide('modal-vincular-turma')
        await this.loadProfessor() // Recarrega os dados
        hideSpinner()
      } catch (error) {
        hideSpinner()
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Erro ao vincular turma',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      }
    },

    async desvincularTurma(turma) {
      try {
        showSpinner()
        
                 await usersService.desvincularTurma({
           professorId: this.professor.id,
           turmaId: turma.id,
           escola: turma.escola,
         })

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Turma desvinculada com sucesso!',
            icon: 'CheckIcon',
            variant: 'success',
          },
        })

        await this.loadProfessor() // Recarrega os dados
        hideSpinner()
      } catch (error) {
        hideSpinner()
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Erro ao desvincular turma',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      }
    },

    resetVinculacaoForm() {
      this.vinculacaoForm = {
        schoolId: null,
        classroomId: null,
      }
      this.classroomOptions = []
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

#modal-vincular-turma .modal-dialog {
    height: 400px;  
}
</style>
